const content = (
  <div>
    <p>
      Les personnalités difficiles dans une équipe sont un frein au travail
      collectif. Le manager doit apprendre à les canaliser. Ce stage vous
      permettra de perfectionner votre communication et de choisir la meilleure
      posture relationnelle afin de rétablir le dialogue pour une collaboration
      efficace.
    </p>
    <h2>Objectifs pédagogiques</h2>
    <p>À l’issue de la formation, le participant sera en mesure de :</p>
    <ul>
      <li>Renforcer l'estime de soi</li>
      <li>Adapter sa communication à ses interlocuteurs</li>
      <li>Mener des entretiens de recadrage</li>
      <li>S'affirmer face à des collaborateurs difficiles</li>
      <li>Gérer les situations conflictuelles</li>
    </ul>
    <h2>Public concerné</h2>
    <p>Managers d'équipe.</p>
    <h2>Prérequis</h2>
    <p>Aucune connaissance particulière.</p>

    <h2>Méthodes et moyens pédagogiques</h2>
    <p>
      Travaux pratiques. Mises en situation et débriefing personnalisé et en
      groupe, réflexion individuelle sur ses forces et ses potentialités.
    </p>
    <h2>Modalités d'évaluation</h2>
    <p>
      Le formateur évalue la progression pédagogique du participant tout au long
      de la formation au moyen de QCM, mises en situation, travaux pratiques… Le
      participant complète également un test de positionnement en amont et en
      aval pour valider les compétences acquises.
    </p>
    <h2>Programme de la formation</h2>
    <h3>1/ Comprendre pourquoi un interlocuteur devient difficile</h3>
    <ul>
      <li>Identifier les comportements.</li>
      <li>Impact dans les relations de travail.</li>
      <li>Assertivité : une technique gagnante ?</li>
    </ul>
    <p>Travaux pratiques : Échange collectif.</p>
    <h3>2/ Renforcer l'estime de soi et s'affirmer</h3>
    <ul>
      <li>
        Identifier les trois ressources nécessaires à l'estime et l'affirmation
        de soi.
      </li>
      <li>Cibler ses points forts et ses axes de développement.</li>
      <li>Comprendre son propre cadre de référence.</li>
      <li>Distinguer les six niveaux logiques.</li>
    </ul>
    <p>
      Travaux pratiques : Entretien avec un collaborateur en utilisant les trois
      niveaux de communication. Travail en binôme avec restitution.
    </p>

    <h3>3/ Construire un état d'invulnérabilité et de 'non-insultabilité'</h3>
    <ul>
      <li>
        Contourner les jugements hâtifs, les critiques, les reproches et les
        insultes.
      </li>
      <li>Positiver : utiliser la critique de manière constructive.</li>
      <li>
        Éviter la posture défensive. - Construire et ancrer un état
        d'invulnérabilité.
      </li>
    </ul>
    <p>
      Travaux pratiques : Résister à l'assaut verbal et agressif de son
      interlocuteur.
    </p>

    <h3>4/ Calibrer sa communication à ses interlocuteurs</h3>
    <ul>
      <li>Différents types de personnalités difficiles.</li>
      <li>Adapter son niveau de communication.</li>
      <li>Rapport oppresseurs/oppressés.</li>
      <li>Mieux gérer les états de stress.</li>
    </ul>
    <p>
      Travaux pratiques : Mises en situation d'entretien pour ajuster son mode
      de communication et débriefing.
    </p>

    <h3>5/ Manager les collaborateurs difficiles</h3>
    <ul>
      <li>
        Leviers d'action : désynchronisation, questionnement de pertinence,
        humour et plaisanterie, prise en compte...
      </li>
      <li>
        Distinguer leurs états de stress et comment les désamorcer ou les
        détourner ?
      </li>
      <li>Se positionner et instaurer un climat de travail sain.</li>
    </ul>
    <p>
      Travaux pratiques : Mises en situation d'entretien de découverte des
      leviers motivationnels et débriefing.
    </p>

    <h3>6/ Mener des entretiens de recadrage</h3>
    <ul>
      <li>L'entretien avec faits et sans faits.</li>
      <li>Dire ce qui ne va pas sans démotiver.</li>
      <li>Pratiquer le feedback durant l'entretien.</li>
      <li>Impliquer le collaborateur dans la recherche de solution.</li>
    </ul>
    <p>
      Travaux pratiques : Préparation et simulation des entretiens avec jeux de
      rôles filmés.
    </p>

    <h3>7/ Dépasser les situations conflictuelles</h3>
    <ul>
      <li>Identifier les causes profondes.</li>
      <li>
        Comprendre les sources du conflit, se positionner et communiquer en
        conséquence.
      </li>
    </ul>
    <p>
      Travaux pratiques : Mises en situation de conflits relationnels pour
      trouver sa posture managériale.
    </p>
  </div>
);

export default content;
